/* dv-parca-rulo.js — [DV-PARCA-RULO 2026-08-02]
   PARCA (dikdortgen hazir ebat) urunlerinde RULO YEDEGI.

   Kural (magaza sahibi karari):
   - Hazir ebat Shopify varyanti STOKTA ise → NATIVE akis, bu script HICBIR SEYE DOKUNMAZ.
   - Varyant TUKENDIYSE → canli Nebim rulo stoguna bakilir (check-roll-availability).
     Rulo VARSA: ebat "Stokta" gosterilir, fiyat = KESIM FIYATI (birim(rulo) x boy),
     sepete Model A gizli kesim kalemi duser (varyant=rulo eni, adet=boy cm).
     Musteri normal parca halinde siparis verir; kesim arka planda yapilir.
     Rulo da YOKSA: ebat gercekten tukenmis kalir.
   Kapsam: window.__DV_PARCA_RULO__.urunler icinde handle'i olan urunler. Digerlerine DOKUNMAZ.
   Iki sayfa sablonu desteklenir: dv-fixed-option3 (Hazir ebatlar UI) ve standart hdt variant-picker. */
(function () {
  'use strict';
  var TAG = '[DVParcaRulo]';

  function fmtTL(n) {
    return Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function init() {
    var D = window.__DV_PARCA_RULO__;
    var handle = window.__DV_SR_HANDLE__;
    if (!D || !D.urunler || !handle) return;
    var cfg = D.urunler[handle];
    if (!cfg) return; // kapsam disi urun
    var API = D.api;
    var OLC = cfg.olculer || {};          // vid -> {en,boy,rulo,bar,kvid,birim,fiyat,olcu}
    var fallback = {};                    // vid -> rec : varyant tukendi + RULO VAR
    var nativeOk = {}; // [DV-PR-BILDIRIM] native stokta olan varyantlar
    var kontrolde = {};                   // vid -> rec : rulo sorgusu SURUYOR ("Kontrol ediliyor…")
    var busy = false;
    var stokCache = {};
    var STOK_TTL = 60000;

    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function rollCheck(rec, taze) {
      var key = rec.bar + '|' + rec.boy;
      var c = stokCache[key];
      if (!taze && c && Date.now() - c.t < STOK_TTL) return Promise.resolve(c.data);
      return fetch(API + '/check-roll-availability?barcode=' + encodeURIComponent(rec.bar) + '&length=' + (rec.boy / 100) + (taze ? '&_t=' + Date.now() : ''))
        .then(function (x) { return x.json(); })
        .then(function (d) { stokCache[key] = { t: Date.now(), data: d }; return d; })
        .catch(function () { return null; });
    }

    function currentVid() {
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return el ? String(el.value) : null;
    }
    function selRec() { var v = currentVid(); return v && fallback[v] ? fallback[v] : null; }

    function adetAl(form) { // [DV-SR-ADET-FIX] adet girisi formun DISINDA olabilir
      var q = form ? form.querySelector('[name="quantity"]') : null;
      if (!q && form && form.id) q = document.querySelector('[name="quantity"][form="' + form.id + '"]');
      if (!q) q = document.querySelector('form[action*="/cart/add"] [name="quantity"], [name="quantity"]');
      var n = parseInt(q && q.value, 10) || 1;
      return Math.max(1, Math.min(5, n));
    }

    /* ── Model A kesim kalemi (dv-sabit-rulo ile ayni protokol) ── */
    function sepeteEkle(r, adet) {
      var satir = Math.round(r.birim * r.boy * 100) / 100;
      if (Math.abs(satir - r.fiyat) > 0.01) { // FIYAT KAPISI
        console.error(TAG, 'FIYAT KAPISI kapali', satir, r.fiyat);
        alert('Fiyat doğrulaması başarısız oldu, ürün sepete eklenmedi.');
        return Promise.reject(new Error('fiyat kapisi'));
      }
      var zincir = Promise.resolve();
      var sonYanit = null;
      for (var i = 0; i < adet; i++) {
        (function (son) {
          zincir = zincir.then(function () {
            var props = {
              'Model': cfg.ad,
              'Halı Şekli': 'Dikdörtgen',
              'Genişlik': r.en + 'cm (' + r.rulo + 'cm rulo)',
              'Uzunluk': r.boy + 'cm',
              'Kenar Tipi': 'Overlok',
              'Toplam m²': ((r.rulo * r.boy) / 10000).toFixed(2),
              '_rollBarcode': r.bar,
              '_snapWidth': String(r.rulo),
              '_edgeType': 'overlok',
              '_shapeType': 'dikdortgen',
              '_sabitOlcu': r.olcu,
              '_satirId': 'pr_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 5),
              '_kesimVaryantId': String(r.kvid),
              '_birimFiyat': String(r.birim),
              '_sayfaTutar': String(r.fiyat),
              '_kaynakUrl': kok + 'products/' + handle
            };
            if (window.__DV_SR_IMG__) props['Onizleme'] = window.__DV_SR_IMG__;
            var sections = [];
            if (son) {
              try { document.dispatchEvent(new CustomEvent('cart:push:section.id', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
            }
            var fd = new FormData();
            fd.append('id', String(r.kvid));
            fd.append('quantity', String(r.boy));
            Object.keys(props).forEach(function (k) {
              if (props[k] === null || props[k] === undefined || props[k] === '') return;
              fd.append('properties[' + k + ']', String(props[k]));
            });
            if (sections.length) fd.append('sections', sections.join(','));
            return fetch(kok + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (resp) {
                return resp.json().catch(function () { return null; }).then(function (data) {
                  if (!resp.ok) throw new Error((data && (data.description || data.message)) || 'Ürün sepete eklenemedi.');
                  /* [KESIM-CANLI-FIYAT 2026-08-29] TAHSILAT DOGRULAMASI: sepet satiri
                     birim fiyati sayfada gosterilen birimden farkliysa satir GERI ALINIR;
                     musteri asla gosterilenden farkli odemez (kvid fiyati dalga ile
                     degisebilir; 90 sn onbellek payi). */
                  var beklenenKurus = Math.round(r.birim * 100);
                  if (data && data.key && Number.isFinite(Number(data.price)) && Number(data.price) !== beklenenKurus) {
                    console.error(TAG, 'TAHSILAT DOGRULAMASI: satir', data.price, 'beklenen', beklenenKurus, '- satir geri aliniyor');
                    return fetch(kok + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: data.key, quantity: 0 }) })
                      .catch(function () {})
                      .then(function () { throw new Error('Fiyat az önce güncellendi — lütfen sayfayı yenileyip tekrar deneyin.'); });
                  }
                  if (son) sonYanit = data;
                  return data;
                });
              });
          });
        })(i === adet - 1);
      }
      return zincir.then(function () {
        return fetch(kok + 'cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (cart) {
          if (sonYanit && sonYanit.sections) cart.sections = sonYanit.sections;
          document.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', actionAfterATC: 'open_cart_drawer', cart: cart }
          }));
          console.log(TAG, 'sepete eklendi (rulo yedegi):', cfg.ad, r.olcu, '=', fmtTL(r.fiyat), 'x', adet);
          return true;
        });
      });
    }

    /* ── stok mesaji ── */
    function msgEl() {
      var el = document.getElementById('dv-pr-stok');
      if (!el) {
        el = document.createElement('div');
        el.id = 'dv-pr-stok';
        el.style.cssText = 'margin:8px 0;font-size:13px;line-height:1.4;';
        var host = document.querySelector('.hdt-product__buy-button') || document.querySelector('form[action*="/cart/add"]');
        if (host) host.parentNode.insertBefore(el, host);
      }
      return el;
    }
    function toggleMsg(html, renk) {
      var el = msgEl();
      if (!el) return;
      if (!html) { el.style.display = 'none'; el.innerHTML = ''; return; }
      el.style.display = '';
      el.style.color = renk || '#1a7f37';
      el.innerHTML = html;
    }

    /* ── "Kontrol ediliyor…" ara durumu [DV-PR-KONTROL 2026-08-02] ──
       Sayfa ilk acildiginda tukenmis gorunup 2-3 sn sonra "Stokta"ya donmesi kafa karistiriyordu.
       Rulo sorgusu surerken cip notr + kucuk soluk "Kontrol ediliyor…" gosterilir (sade, animasyon
       sadece minik durum yazisinda). */
    function kontrolCss() {
      if (document.getElementById('dv-pr-kontrol-css')) return;
      var s = document.createElement('style');
      s.id = 'dv-pr-kontrol-css';
      s.textContent =
        '[data-dv-fixed-option3] label[data-dv-checking]{color:#8c8884 !important;background:#fff !important;border-color:#e2ddd6 !important;}' +
        '[data-dv-fixed-option3] label[data-dv-checking], [data-dv-fixed-option3] label[data-dv-checking] *{text-decoration:none !important;}' +
        '[data-dv-fixed-option3] label[data-dv-checking] .dv-fixed-option3__variant-status{color:#8c8884 !important;font-weight:400;animation:dvPrNabiz 1.2s ease-in-out infinite;}' +
        '@keyframes dvPrNabiz{50%{opacity:.35}}';
      document.head.appendChild(s);
    }
    function chipEtiket(olcu) {
      var hedef = olcu.replace(/\s+/g, '').toLowerCase();
      var inp = [...document.querySelectorAll('[data-dv-fixed-option3] input[type="radio"]')]
        .find(function (i) { return (i.value || '').replace(/\s+/g, '').toLowerCase() === hedef; });
      if (!inp) return null;
      return inp.closest('label') || (inp.id && document.querySelector('label[for="' + inp.id + '"]')) || null;
    }
    function kontrolCiz() {
      kontrolCss();
      Object.keys(kontrolde).forEach(function (vid) {
        var lab = chipEtiket(kontrolde[vid].olcu);
        if (!lab) return;
        lab.setAttribute('data-dv-checking', '1');
        var st = lab.querySelector('.dv-fixed-option3__variant-status');
        if (st && st.textContent !== 'Kontrol ediliyor…') st.textContent = 'Kontrol ediliyor…';
      });
      // sonuclananlarin ara-durum izini temizle
      Object.keys(OLC).forEach(function (vid) {
        if (kontrolde[vid]) return;
        var lab = chipEtiket(OLC[vid].olcu);
        if (!lab || !lab.hasAttribute('data-dv-checking')) return;
        lab.removeAttribute('data-dv-checking');
        var st = lab.querySelector('.dv-fixed-option3__variant-status');
        if (st && st.textContent === 'Kontrol ediliyor…') st.textContent = fallback[vid] ? 'Stokta' : 'Tükendi';
      });
    }

    /* ── dv-fixed-option3 entegrasyonu ── */
    function opt3Inst() {
      var r = document.querySelector('[data-dv-fixed-option3]');
      var api = window.DvFixedProductOption3;
      return (r && api && api.getInstance && api.getInstance(r)) || null;
    }
    function opt3Uygula() {
      var inst = opt3Inst();
      if (!inst || !inst.variants) return false;
      var root = document.querySelector('[data-dv-fixed-option3]');
      var n = 0;
      Object.keys(fallback).forEach(function (vid) {
        var v = inst.variants.get(String(vid));
        if (!v) return;
        n++;
        v.__dvParca = true;
        v.available = true;                                  // idempotent — her seferinde zorla
        var kesimKurus = Math.round(fallback[vid].fiyat * 100);
        /* [DV-INDIRIM-SOZLESME 2026-08-26] Orijinal varyant fiyatini sakla: sozlesme,
           gosterilen fiyat varyant fiyatindan ayrisiyorsa (kesim) hicbir indirim/min
           iddiasi gostermemek icin bunu kullanir. */
        if (v.__dvVaryantKurus == null) v.__dvVaryantKurus = v.priceCents;
        /* [KESIM-LISTE-KAPISI 2026-08-26] Kesim fiyati varyantin KENDI fiyatiyla birebir ayni
           ise varyantin listesi (compare_at) ve dalga isareti GECERLIDIR; silmek magazayi
           oldugundan pahali gosterir (26 Agu: Opera 8504 80x150'de 6.263,40 liste kayboluyordu).
           Fiyatlar ayrisiyorsa (dalga varyanta yazilmis ama kesim tasimiyor) hicbir indirim
           iddiasi gosterilmez — eski davranis aynen surer. */
        if (v.__dvCmpOrj == null) v.__dvCmpOrj = v.compareAtCents;
        if (v.__dvAlgOrj === undefined) v.__dvAlgOrj = v.algorithm;
        /* [KESIM-CANLI-FIYAT 2026-08-29] Karsilastirma HER ZAMAN varyantin ORIJINAL
           fiyatiyla (__dvVaryantKurus) yapilir; esitlikte orijinal liste/rozet GERI
           YUKLENIR. Boylece canli kvid fiyati sonradan gelip kesim fiyatini varyant
           fiyatina esitlerse (dalga kvid'e de yazildiysa) liste + dalga isareti geri
           gelir; esitlik yoksa eski davranis (hicbir indirim iddiasi) aynen surer. */
        if (kesimKurus === v.__dvVaryantKurus) {
          v.priceCents = v.__dvVaryantKurus;
          v.compareAtCents = v.__dvCmpOrj;
          v.algorithm = v.__dvAlgOrj;
          return;
        }
        v.priceCents = kesimKurus;                            // KESIM FIYATI
        v.compareAtCents = 0;                                 // sahte indirim rozeti olmasin
        v.algorithm = null;
      });
      if (!n || !root) return true;
      // BAYAT DOM TESPITI: opt3 bizden SONRA yeniden cizmis olabilir (chip input degeri
      // varyant id DEGIL "80x150" gibi olcu metnidir) — durum hala Tukendi/disabled ise yeniden boya.
      var bayat = false;
      Object.keys(fallback).forEach(function (vid) {
        var olcu = fallback[vid].olcu.toLowerCase();
        root.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          if ((inp.value || '').replace(/\s+/g, '').toLowerCase() !== olcu) return;
          if (inp.disabled) bayat = true;
          var lab = inp.closest('label') || (inp.id && document.querySelector('label[for="' + inp.id + '"]'));
          var st = lab && lab.querySelector('.dv-fixed-option3__variant-status');
          if (st && /tükendi|tukendi/i.test(st.textContent || '')) bayat = true;
        });
      });
      if (bayat) {
        /* NOT: decorateVariants disabled/is-disabled'i TEMIZLEMEZ, yalniz !available iken EKLER.
           Temizligi hdtRadioAc yapar ([DV-PR-IMLEC]). */
        try { inst.decorateVariants && inst.decorateVariants(); } catch (e) {}
        try { inst.render && inst.render(); } catch (e) {}
      }
      return true;
    }

    /* ── hdt (standart) sayfa: secili ebat fallback ise fiyat/buton düzelt ── */
    var applying = false;
    function applyPrice() {
      var r = selRec();
      if (!r) return; // native durumda fiyata DOKUNMA
      applying = true;
      try {
        document.querySelectorAll('.hdt-product__price .hdt-price__list').forEach(function (pl) {
          pl.querySelectorAll('.hdt-compare-at-price').forEach(function (e) { e.style.display = 'none'; });
          pl.querySelectorAll('.discount-badge').forEach(function (e) { e.remove(); });
          var target = null;
          var cands = pl.querySelectorAll('span, div, bdi');
          for (var i = 0; i < cands.length; i++) {
            var t = (cands[i].textContent || '').trim();
            if (/\d/.test(t) && /TL|₺/.test(t) && cands[i].children.length === 0 && cands[i].offsetParent !== null) { target = cands[i]; break; }
          }
          if (target && target.textContent.trim() !== fmtTL(r.fiyat)) target.textContent = fmtTL(r.fiyat);
        });
        document.querySelectorAll('.taksit-tutari').forEach(function (el) {
          el.textContent = (r.fiyat / 6).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
        var kurus = String(Math.round(r.fiyat * 100));
        document.querySelectorAll('form[action*="/cart/add"] hdt-qty-price').forEach(function (qp) {
          if (qp.getAttribute('variant-price') !== kurus) qp.setAttribute('variant-price', kurus);
          var adet = adetAl(qp.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'));
          var mny = qp.querySelector('.hdt-money');
          var yazi = fmtTL(r.fiyat * adet);
          if (mny && mny.textContent.trim() !== yazi) mny.textContent = yazi;
        });
      } finally {
        setTimeout(function () { applying = false; }, 0);
      }
    }
    function atcEnable(r) {
      document.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]').forEach(function (b) {
        b.disabled = false;
        var sp = b.querySelector('.hdt-btn-atc_text') || b.querySelector('span') || b;
        if (/tükendi|tukendi/i.test(sp.textContent || '')) sp.textContent = 'Sepete ekle';
      });
    }
    function hdtRadioAc() {
      // hdt secicideki tukenmis gorunumlu ebat girislerini fallback icin ac
      Object.keys(fallback).forEach(function (vid) {
        var olcu = fallback[vid].olcu;
        document.querySelectorAll('hdt-variant-picker input').forEach(function (inp) {
          if ((inp.value || '').replace(/\s+/g, '').toLowerCase() !== olcu.toLowerCase()) return;
          inp.disabled = false;
          inp.removeAttribute('aria-disabled');
          /* [DV-PR-IMLEC 2026-08-03] Tema kurali `disabled` OZELLIGINE degil `is-disabled`
             SINIFINA bakiyor:
             `.dv-fixed-option3__variants input.is-disabled + .hdt-product-form_value{cursor:not-allowed}`
             opt3'un decorateVariants'i bu sinifi SADECE EKLIYOR, hicbir zaman kaldirmiyor —
             biz available=true yapinca o dal calismadigi icin sinif kaliyordu: chip tiklanabilir
             oluyor ama imlec "satilamaz" gosteriyordu. Kaynakta temizlenir; available=true oldugu
             icin decorateVariants geri EKLEMEZ (tek yonlu kapi), titreme olmaz. */
          inp.classList.remove('is-disabled');
          var lab = inp.closest('label') || (inp.id && document.querySelector('label[for="' + inp.id + '"]'));
          if (lab && !lab.hasAttribute('data-dv-parca-ok')) lab.setAttribute('data-dv-parca-ok', '1');
        });
      });
      if (!document.getElementById('dv-pr-css')) {
        var s = document.createElement('style');
        s.id = 'dv-pr-css';
        s.textContent = 'label[data-dv-parca-ok],[data-dv-parca-ok] *{opacity:1 !important;text-decoration:none !important;}' +
          /* [DV-PR-IMLEC] sinif bir sekilde geri gelirse diye ikinci savunma katmani */
          'label[data-dv-parca-ok],[data-dv-parca-ok] *{cursor:pointer !important;}' +
          '[data-dv-parca-ok]{pointer-events:auto !important;}' +
          '[data-dv-parca-ok] .hdt-cross, [data-dv-parca-ok]:after{display:none !important;}';
        document.head.appendChild(s);
      }
    }

    /* ── ATC kesintisi (yalniz fallback secimlerinde) ── */
    function ekleAkisi(form) {
      var r = selRec();
      if (!r || busy) return false;
      busy = true;
      var adet = adetAl(form);
      toggleMsg('Stok kontrol ediliyor…', '#666');
      rollCheck(r, true).then(function (d) {
        if (!d || !d.available) {
          delete fallback[currentVid()];
          toggleMsg('Stok durumu değişti — bu ölçü için uygun rulo yok.', '#b3261e');
          busy = false;
          uygula();
          return;
        }
        toggleMsg(null);
        sepeteEkle(r, adet)
          .catch(function (e) { console.error(TAG, e); toggleMsg('Sepete eklenemedi: ' + e.message, '#b3261e'); })
          .then(function () { busy = false; });
      });
      return true;
    }
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"], [data-dv-fixed-sticky-button]') : null;
      if (!t) return;
      if (!selRec()) return; // native akis
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ekleAkisi(t.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'));
    }, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!selRec()) return; // native akis
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ekleAkisi(form);
    }, true);

    /* ── secim degisince ── */
    function secimGuncelle() {
      var r = selRec();
      if (r) {
        applyPrice();
        atcEnable(r);
        toggleMsg('✓ ' + r.rulo + ' cm ruloda ' + (r.__top || '') + ' uygun top — ölçünüz rulodan kesilerek hazırlanır');
      } else {
        toggleMsg(null); // native
      }
    }
    document.addEventListener('change', function (ev) {
      if (ev.target && (ev.target.name === 'id' || (ev.target.matches && ev.target.matches('input[type="radio"], select, [name="quantity"]')))) {
        setTimeout(secimGuncelle, 60);
      }
    }, true);

    /* ── [DV-PR-BILDIRIM 2026-08-02] "Stokta oldugunda bana bildir" bloku ──
       Secili ebat SATILABILIRSE (native stok VEYA rulo yedegi VEYA kontrol suruyor)
       bildirim formu gizlenir; ebat gercekten olu ise (rulo da yok) form gorunur kalir.
       1sn bekci ile yeniden uygulanir (tema kendi toggle'ini calistirabilir). */
    function bildirimAyarla() {
      var el = document.querySelector('hdt-back-instock');
      if (!el) return;
      var v = currentVid();
      var satilabilir;
      if (v && (OLC[v] || nativeOk[v])) {
        satilabilir = !!(fallback[v] || nativeOk[v] || kontrolde[v]);
      } else {
        var vids = Object.keys(OLC);
        satilabilir = vids.length > 0 && vids.every(function (id) { return fallback[id] || nativeOk[id] || kontrolde[id]; });
      }
      if (satilabilir) { el.setAttribute('hidden', ''); el.style.display = 'none'; }
      else { el.removeAttribute('hidden'); el.style.display = ''; }
    }

    /* ── ana uygulama dongusu ── */
    function uygula() {
      var op = opt3Uygula();
      if (!op) hdtRadioAc();
      else hdtRadioAc(); // opt3 sayfasinda da alttaki hdt radyolar senkron kalsin
      kontrolCiz();
      secimGuncelle();
      bildirimAyarla();
    }

    /* [KESIM-CANLI-FIYAT 2026-08-29] Kesim fiyatinin kaynagi CANLI kvid varyant
       fiyatidir (panel /kesim-fiyat, 90 sn onbellekli). Statik veri dosyasi yalniz
       baslangic/yedek degerdir. Firsat dalgasi kvid fiyatini indirdiginde sayfa,
       sepet ve tahsilat ayni rakami soyler; dalga yokken birebir ayni kalir. */
    (function () {
      var kvidSet = {};
      Object.keys(OLC).forEach(function (vid) { var o = OLC[vid]; if (o && o.kvid != null) kvidSet[String(o.kvid)] = 1; });
      var liste = Object.keys(kvidSet);
      if (!liste.length) return;
      fetch(API + '/kesim-fiyat?kvids=' + liste.join(','))
        .then(function (x) { return x.json(); })
        .then(function (d) {
          var f = (d && d.fiyatlar) || {};
          var degisti = false;
          Object.keys(OLC).forEach(function (vid) {
            var o = OLC[vid];
            var kurus = o && o.kvid != null ? Number(f[String(o.kvid)]) : NaN;
            if (!Number.isFinite(kurus) || kurus <= 0) return;
            var yeniBirim = kurus / 100;
            if (Math.abs(yeniBirim - o.birim) < 0.005) return;
            o.birim = yeniBirim;
            o.fiyat = Math.round(yeniBirim * o.boy * 100) / 100;
            degisti = true;
          });
          if (degisti) { uygula(); console.log(TAG, '[KESIM-CANLI-FIYAT] canli kvid fiyati uygulandi'); }
        })
        .catch(function () { /* statik birim gecerli kalir */ });
    })();

    /* ── baslangic: Shopify varyant musaitligi + rulo taramasi ── */
    fetch(kok + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (x) { return x.json(); })
      .then(function (p) {
        var isler = [];
        (p.variants || []).forEach(function (v) {
          if (v.available) nativeOk[String(v.id)] = true; // [DV-PR-BILDIRIM]
          var rec = OLC[String(v.id)];
          if (!rec) return;
          if (v.available) return; // PARCA STOKTA -> native, dokunma
          kontrolde[String(v.id)] = rec; // sorgu suresince "Kontrol ediliyor…"
        });
        if (Object.keys(kontrolde).length) { uygula(); setInterval(uygula, 1000); }
        Object.keys(kontrolde).forEach(function (vid) {
          var rec = kontrolde[vid];
          isler.push(rollCheck(rec, false).then(function (d) {
            if (d && d.available) { fallback[vid] = rec; rec.__top = d.suitableRollCount || ''; }
            delete kontrolde[vid];
            uygula();
          }));
        });
        return Promise.all(isler);
      })
      .then(function () {
        var n = Object.keys(fallback).length;
        if (!n) { console.log(TAG, 'aktif:', handle, '- rulo yedegi gereken olcu yok'); return; }
        uygula();
        console.log(TAG, 'aktif:', handle, n + ' olcu rulo yedegine alindi:', Object.keys(fallback).map(function (k) { return fallback[k].olcu; }).join(', '));
      })
      .catch(function (e) { console.error(TAG, 'baslangic hatasi', e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
